import axios from 'axios'

const api = axios.create({
  baseURL: '/api',
  timeout: 60000
})

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem('token')
      const isLoginReq = err.config && err.config.url && err.config.url.includes('/auth/login')
      if (!isLoginReq) {
        window.location.href = '/login'
      }
    }
    return Promise.reject(err)
  }
)

export default {
  getArticles(params) {
    return api.get('/articles/public/list', { params })
  },
  getArticle(id) {
    return api.get(`/articles/public/${id}`)
  },
  getCategories() {
    return api.get('/articles/public/categories')
  },
  login(data) {
    return api.post('/auth/login', data)
  },
  getAllArticles() {
    return api.get('/articles')
  },
  createArticle(data) {
    return api.post('/articles', data)
  },
  updateArticle(id, data) {
    return api.put(`/articles/${id}`, data)
  },
  deleteArticle(id) {
    return api.delete(`/articles/${id}`)
  },
  getCrawlStatus() {
    return api.get('/crawl/status')
  },
  getCrawlTasks() {
    return api.get('/crawl/tasks')
  },
  runCrawl() {
    return api.post('/crawl/run')
  }
}
